module.exports = __webpack_public_path__ + "img/m220 _lite.dd833c2c.dd833c2c.png";